"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var NotificationIcon = function (props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", tslib_1.__assign({ d: "M28 15C28 22.7642 21.9242 29 14.5 29C7.07584 29 1 22.7642 1 15C1 7.23579 7.07584 1 14.5 1C21.9242 1 28 7.23579 28 15Z", stroke: "#196CFF", fill: "none", strokeWidth: "2" }, props)),
        react_1.default.createElement("circle", { cx: "15", cy: "10", r: "1.25", fill: "#196CFF" }),
        react_1.default.createElement("rect", { x: "13.75", y: "13.75", width: "2.5", height: "8.75", rx: "1", fill: "#196CFF" })));
};
exports.NotificationIcon = NotificationIcon;
//# sourceMappingURL=NotificationIcon.js.map